export default __webpack_public_path__ + "static/media/FB.6cf96171.svg";